<template>
    <header :class="['order-header', {'order-header--fullscreen': fullscreen, 'order-header--is-mobile': isMobile}]">
        <div class="order-header-title">
            <template v-if="!fullscreen">{{ title }}</template>
        </div>
        <div v-if="!isMobile" class="order-header-info">
            <span v-if="!fullscreen">{{ info }}</span>
        </div>
        <div class="order-header-actions">
            <template v-if="replacedPhotoProduct && carouselView">
                <a href="#" id="block-view"
                   @click.prevent="$store.dispatch('SET_CAROUSEL_VIEW', null)">
                    <span class="material-icon icon-view_comfortable"></span>
                </a>
                <b-tooltip placement="bottom" target="block-view">
                    {{ $t('helpers.block_view') }}
                </b-tooltip>
            </template>
            <a href="#" id="set-fullscreen" v-if="replacedPhotoProduct"
               @click.prevent="$emit('handle-fullscreen', !fullscreen)">
                <span class="material-icon" :class="fullscreen ? 'icon-fullscreen_exit' : 'icon-fullscreen'"></span>
            </a>
            <b-tooltip v-if="replacedPhotoProduct" placement="bottom" target="set-fullscreen">
                {{ $t('helpers.fullscreen') }}
            </b-tooltip>
            <a href="#" id="set-close" @click.prevent="viewProduct ? $emit('view-product', null) : $emit('close-order-set')">
                <span class="material-icon icon-clear"></span>
            </a>
            <b-tooltip placement="bottom" target="set-close">
                {{ $t('helpers.close') }}
            </b-tooltip>
        </div>
    </header>
</template>

<script>
  import setHeader from 'src/mixins/setHeaderComponent';

  export default {
    mixins: [setHeader],
  };
</script>
